angular.module("variazioneTargato.components", ['app.services']).component("variazioneTargato", {
    templateUrl: "ng/components/variazioneTargato/variazioneTargato.view.html",
    bindings: {

    },
    controllerAs: "variazioneTargatoCtrl",
    controller: function VariazioneTargato(
        $location,
        $transactionFactory,
        $modalService,
        $arcService,
        $RichiestePostVenditaService,
        $rootScope,
        RichiestePostVendita,
        Contratti
    ) {
        var self = this;

        self.$onInit = function () {
            self.showMapInfo = false;
            self.mapInfo = "";
            var model = $transactionFactory.get();
            if (model.viewIndex == 0) {
                model.viewIndex = 1250;
            }
            if (model) {
                self.richiestePostVendita = model;
                $transactionFactory.clear();
            } else {
                self.richiestePostVendita = RichiestePostVendita.build();
            }
            self.visibleDownloadChecklist = true;
            self.visibleUploadChecklist = true;

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.richiestePostVendita.readOnly) {
                self.popolateCheckListDownload();
                self.popolateCheckListUpload();
            }

            var contratti = [];
            if (self.richiestePostVendita.metadata.contrattoTargato.contratti.length == 0 ||
                (self.richiestePostVendita.metadata.contrattoTargato.numero != null &&
                    self.richiestePostVendita.metadata.contrattoTargato.modulo != null)) {
                self.richiestePostVendita.metadata.ctrRichiestaList.forEach(function (contratto) {
                    contratti.push(Contratti.build({
                        numero: contratto.numeroContratto,
                        modulo: contratto.numeroModulo,
                        selected: true,
                        codProdotto: contratto.codProdotto,
                        dscProdotto: contratto.dscProdotto,
                        importo: contratto.importo
                    }));
                });

                self.richiestePostVendita.metadata.contrattoTargato.contratti = contratti;
            }

            retrieveStepInfo();
        };

        self.popolateCheckListDownload = function () {
            self.restDownloadRunning = true;
            $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentDownload = response.listDocuments;
                    self.visibleDownloadChecklist = response.visible;
                    self.restDownloadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restDownloadRunning = false;
                })
        }

        self.validityPage = function (validity) {
            self.enableNext = validity;
            self.nextValidity();
        }

        self.allegatiChange = function (value) {
            if (self.richiestePostVendita.metadata.contrattoTargato.allegati.length > 0) {
                self.richiestePostVendita.metadata.contrattoTargato.allegati.push(value);
            } else {
                self.richiestePostVendita.metadata.contrattoTargato.allegati[0] = value;
            }
        }

        self.popolateCheckListUpload = function () {
            self.restUploadRunning = true;
            $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentUpload = response.listDocuments;
                    self.visibleUploadChecklist = response.visible;
                    self.message = response.message;
                    self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }

        self.formIsOk = function () {
            self.enableNext = true;
            self.validityPage(self.enableNext);
        }

        self.formIsNotOk = function () {
            self.enableNext = false;
            self.validityPage(self.enableNext);
        }

        self.nextValidity = function () {
            return self.enableNext;
        }

        self.backValidity = function () {
            return (self.getWizardMap(self.richiestePostVendita.viewIndex) !== 'PVT1') || self.richiestePostVendita.readOnly ? true : false;
        }

        self.next = function () {
            self.enabledLoader = true;
            cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName)
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PVT1') {
                $RichiestePostVenditaService
                    .generateDocumentsPv(self.richiestePostVendita)
                    .then(function (response) {
                        if (response.success) {
                            $RichiestePostVenditaService
                                .nextStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                .then(function (response) {
                                    self.enabledLoader = false;
                                    self.richiestePostVendita = response;

                                    if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                                        retrieveStepInfo();
                                        self.popolateCheckListDownload();
                                        self.popolateCheckListUpload();
                                    }

                                }).catch(function (error) {
                                    console.log(error);
                                    self.enabledLoader = false;
                                });
                        } else {
                            self.enabledLoader = false;
                        }

                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    });
            } else if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                $RichiestePostVenditaService
                    .submitVariaTar(self.richiestePostVendita.metadata.contrattoTargato, self.richiestePostVendita.id,
                        self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                    .then(function (response) {
                        if (response.success) {
                            $location.path('/');
                        }
                        self.enabledLoader = false;

                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    });
            }
        }

        self.sospendi = function () {
            $RichiestePostVenditaService
                .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function () {
                    $location.path('/');
                    $modalService.closeModal("suspendInstance");
                })
        }

        self.back = function () {
            if (self.richiestePostVendita.readOnly) {
                $location.path('/')

            } else {
                $RichiestePostVenditaService
                    .backStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                    .then(function (response) {
                        self.enabledLoader = false;
                        self.richiestePostVendita = response;
                        retrieveStepInfo();
                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    })
            }
        }

        self.closeModal = function () {
            $modalService.closeModal("suspendInstance");
        }

        self.getWizardMap = function (viewIndex) {
            if (
                $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                })
            ) {
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                }).viewName;
            }
        };

        var retrieveStepInfo = function () {
            self.clearLabelInfo = true;
            $RichiestePostVenditaService
                .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                .then(function (response) {
                    if (response.success) {
                        self.showMapInfo = response.showBeMessage;
                        self.mapInfo = response.message;
                        self.enabledLoader = false;
                    }
                    self.clearLabelInfo = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                    self.clearLabelInfo = false;
                });
        }
    }
});